module.exports = __webpack_public_path__ + "HoeschLogo.png?52070bbc3ff2b03524fcbf93ed3f9a4f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HoeschLogo.png
// module id = 568
// module chunks = 0